import api from './api';

const adminProductCategoryService = {
  // Get all product categories (includes inactive ones for admin)
  getProductCategories: async () => {
    try {
      const response = await api.get('/products/admin/categories/');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to fetch product categories'
      };
    }
  },

  // Create new product category
  createProductCategory: async (data) => {
    try {
      const response = await api.post('/products/admin/categories/', data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to create product category'
      };
    }
  },

  // Update product category
  updateProductCategory: async (id, data) => {
    try {
      const response = await api.patch(`/products/admin/categories/${id}/`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to update product category'
      };
    }
  },

  // Delete product category
  deleteProductCategory: async (id) => {
    try {
      await api.delete(`/products/admin/categories/${id}/`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Failed to delete product category'
      };
    }
  }
};

export default adminProductCategoryService;
